import { useRouteError, isRouteErrorResponse, Link } from "react-router-dom";
import { ErrorLayout } from "@/layouts";

export function RouteErrorPage() {
  const error = useRouteError();
  let title = "Something went wrong";
  let description =
    "The page could not be loaded. Your work was not confirmed as completed.";

  if (isRouteErrorResponse(error)) {
    title = `${error.status} ${error.statusText}`;
    description =
      typeof error.data === "string"
        ? error.data
        : "A routing error occurred.";
  } else if (error instanceof Error) {
    description = error.message;
  }

  return (
    <ErrorLayout
      title={title}
      description={description}
      action={<Link to="/app">Return to foundation</Link>}
    />
  );
}
